import { Model } from 'json-api-models';

import { Models, Product, Schemas } from '../models.ts';

export class Tutorial extends Model<Schemas['tutorials'], Models> {
    shareUrl(product: Product): string {
        return import.meta.env.VITE_BASE_URL + `/${product.slug}/cases/${this.item?.id}`;
    }
}
